/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StarIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABXElEQVR4nOWTPUvEQBCG70QsRUTBH6IEqyB+ELzMR4rNTBDORmwtLa+zEmyt7j+oheKP0FpsBRXB0lPhUFYwxlw4d7004sLAsjv7Pruz7zQa/2ZE0cYksFwCy4Wd1w4gyraQ9c0GsGzXDkCS0wLgrFZxos0pIH3JASSvxpjp2gCIaftTPA9M27UBgOWoDLBrnrfUeUzElINIBEl6Ay8g6X3sVZyJk3Thm3hMsjwgMGLELGvF2wdA0q9LHEj6MWeLpRKlS8h6MzpA7iDRqPIf4jibAZbjX4uTnK8bM/fTfzdtpwLpk4f4M5DsdjqdMR9XBc4A1MBZOAck2nIGJNryBgBr19k1rF0v8TAMx5HlwcM5j8aYCffyYLpS5W0k2bNR1TOQ6KpHeeRwmLexomfsGXcA6dWXt/UkMma2nGPX7F4Bcu0MQJZ9JL1Flh3bF0NSmzYHSO6R5cAZ8KfGO7VAqWSkvq3TAAAAAElFTkSuQmCC)
 */
export const StarIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M10.81 2.86c.38-1.15 2-1.15 2.38 0l1.89 5.83h6.12c1.2 0 1.71 1.54.73 2.25l-4.95 3.6 1.9 5.82a1.25 1.25 0 0 1-1.93 1.4L12 18.16l-4.95 3.6c-.98.7-2.3-.25-1.92-1.4l1.89-5.82-4.95-3.6a1.25 1.25 0 0 1 .73-2.25h6.12l1.9-5.83Z"
        className={colorClass}
      />
    </svg>
  );
};
